/**
 * Teacher Profile Selectors
 * Memoized selectors for teacher profile state
 */

import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../index";

// Base selector
const selectTeacherProfileState = (state: RootState) => state.teacherProfile;

// Memoized selectors
export const selectTeacherProfile = createSelector(
  [selectTeacherProfileState],
  (state) => state.data
);

export const selectTeacherProfileLoading = createSelector(
  [selectTeacherProfileState],
  (state) => state.loading
);

export const selectTeacherProfileError = createSelector(
  [selectTeacherProfileState],
  (state) => state.error
);

export const selectUploadProgress = createSelector(
  [selectTeacherProfileState],
  (state) => state.uploadProgress
);

export const selectIsProfileCached = createSelector(
  [selectTeacherProfileState],
  (state) => {
    if (!state.data || !state.lastFetched) return false;
    const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
    return Date.now() - state.lastFetched < CACHE_DURATION;
  }
);

// Computed selectors
export const selectUserInitials = createSelector(
  [selectTeacherProfile],
  (profile) => {
    if (!profile?.name) return "??";
    const names = profile.name.trim().split(" ");
    if (names.length === 1) {
      return names[0].substring(0, 2).toUpperCase();
    }
    return (names[0][0] + names[names.length - 1][0]).toUpperCase();
  }
);

export const selectProfilePhotoUrl = createSelector(
  [selectTeacherProfile],
  (profile) => profile?.photo || null
);
